import { render, staticRenderFns } from "./HqTenantList.vue?vue&type=template&id=33a47ca6"
import script from "./HqTenantList.vue?vue&type=script&lang=js"
export * from "./HqTenantList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports